<template>
	<div class="auth-container">
		<img src="@/assets/logo.svg" alt="CIL Logo" class="logo" />
		<p>
			Bienvenue sur votre Carnet d'Information du Logement (CIL)<br />
			Votre plateforme dédiée au suivi et à la gestion de votre logement.
		</p>
		<component :is="currentForm" />
		<a href="https://mondomicil.fr" class="link backto">Retour sur le site</a>
	</div>
</template>

<script>
import LoginForm from "@/components/LoginForm.vue";
import RegisterForm from "@/components/RegisterForm.vue";
import VerificationForm from "@/components/VerificationForm.vue";
import ResetForm from "@/components/ResetForm.vue";

export default {
	components: {
		LoginForm,
		RegisterForm,
		VerificationForm,
		ResetForm
	},
	props: {
		defaultForm: {
			type: String,
			required: false,
			default: "login",
		},
	},
	data() {
		return {
			currentForm: this.defaultForm === "login" ? "LoginForm" : "RegisterForm",
		};
	},
	methods: {
		async checkUserStatus() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "user/s", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include", });

				if (response.ok) return this.$router.push("/");
			} catch (error) {
				console.error("Erreur lors de la vérification du statut de connexion:", error);
			}
		},
		determineForm() {
			const formMap = {
				"login": "LoginForm",
				"register": "RegisterForm",
				"verification/": "VerificationForm",
				"forgot-password": "ForgotPasswordForm",
				"reset": "ResetForm"
			};

			const path = this.$route.path;

			for (const [key, form] of Object.entries(formMap)) {
				if (path.includes(key)) {
					this.currentForm = form;
					return;
				}
			}

			this.currentForm = null;
		},
		toggleForm() {
			if (this.currentForm === "LoginForm") {
				this.currentForm = "RegisterForm";
				this.$router.push("/register");
			} else {
				this.currentForm = "LoginForm";
				this.$router.push("/login");
			}
		},
	},
	watch: {
		$route() {
			this.determineForm();
		},
	},
	created() {
		this.checkUserStatus();
		this.determineForm();
	},
};
</script>

<style>
.auth-container {
	padding-top: 50px;
	max-width: 700px;
	margin: auto;
	text-align: center;
}

.auth-container>p {
	font-weight: bold;
	font-size: 22px;
}

.logo {
	max-width: 400px;
}

.backto {
	text-decoration: none;
	margin-top: 50px;
}

@media (max-width: 950px) {
	.auth-container {
		padding-top: 20px;
	}

	.logo {
		max-width: 200px;
	}

	.auth-container>p {
		font-weight: bold;
		font-size: 14px;
	}

	.form-container {
		padding: 20px 50px !important;
	}
}
</style>
